import LinkToDocusaurus from '../LinkToDocusaurus'
import { requirements } from '../../docs-routes'

const LinkToRequirementsDoc = () =>
  <LinkToDocusaurus path={requirements}>
    Learn more in the DAI documentation
  </LinkToDocusaurus>

export default LinkToRequirementsDoc
